import { SignIn } from "@clerk/react";
import { ArrowLeft } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";

import { GoogleAuthButton } from "@/components/auth/google-auth-button";
import { Button } from "@/components/ui/button";
import { routes } from "@/routes";

export function SignInPage() {
  const navigate = useNavigate();
  const { t } = useTranslation(["common"]);
  return (
    <div>
      <Button
        variant="ghost"
        className="absolute left-2 top-2 text-neutral-300 no-underline"
        onClick={() => navigate(routes.signup)}
      >
        <ArrowLeft />
        {t("common:back")}
      </Button>

      <SignIn
        signUpUrl={routes.signup}
        routing="hash"
        fallbackRedirectUrl={routes.profile}
        appearance={{
          elements: {
            footerAction: { display: "none" },
            socialButtons: { display: "none" },
            dividerRow: { display: "none" },
          },
        }}
      />
      <GoogleAuthButton />
    </div>
  );
}
